<div class="cards-container">
  <!-- Mes informations -->
  <section class="card" *ngIf="adherent">
    <span class="card-title floating">Mes informations</span>

    <div class="form-row">
      <label>Titulaire :</label>
      <input type="text" [value]="adherent.titulaire" disabled />
    </div>

    <div class="form-row">
      <label>Nom Officine :</label>
      <input type="text" [value]="adherent.nom" disabled />
    </div>

    <div class="form-row">
      <label>N° SIRET :</label>
      <input type="text" [value]="adherent.siret" disabled />
    </div>

    <div class="form-row">
      <label>N° Finess (Sécu) :</label>
      <input type="text" [value]="adherent.codeFiness" disabled />
    </div>

    <div class="form-row">
      <label>N° Finess (Géo) :</label>
      <input type="text" [value]="adherent.codeFinessGeo" disabled />
    </div>

    <div class="form-row">
      <label>LGO :</label>
      <input type="text" [value]="adherent.lgo" disabled />
    </div>

    <div class="form-row">
      <label>CIP :</label>
      <input type="text" [value]="adherent.cip" disabled />
    </div>

    <div class="form-row">
      <label>Adresse :</label>
      <textarea disabled
        >{{ adherent.adresse }}
{{ adherent.cp }} {{ adherent.ville }}</textarea
      >
    </div>
  </section>

  <!-- Télécharger -->
  <section class="card center">
    <span class="card-title floating">Télécharger mon fichier</span>

    <p class="hint">Cliquez pour télécharger le modèle.</p>

    <button class="btn-primary" (click)="downloadTemplate()">Télécharger mon fichier</button>
  </section>

  <!-- Charger -->
  <section class="card center">
    <span class="card-title floating">Charger mon fichier</span>

    <p class="hint">Sélectionnez votre fichier complété.</p>

    <input type="file" hidden #fileInput (change)="onFileSelected($event)" />

    <div
      class="file-box"
      [class.selected]="selectedFile"
      [class.dragging]="isDragging"
      (click)="openFileDialog()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <mat-icon class="upload-icon">upload_file</mat-icon>

      <span class="file-text" *ngIf="!selectedFile"> Glissez votre fichier ici ou cliquez </span>

      <span class="file-text selected" *ngIf="selectedFile">
        {{ selectedFile.name }}
      </span>
    </div>

    <button class="btn-primary" [disabled]="uploading || !selectedFile" (click)="uploadFile()">
      {{ uploading ? 'Envoi en cours...' : 'Envoyer' }}
    </button>
  </section>
</div>

<div class="warning">
  ⚠️ Si les informations ne sont pas correctes, merci de contacter votre groupement.
</div>
